export default __webpack_public_path__ + "static/media/5.9e209b37.jpg";